module.exports = __webpack_public_path__ + "img/yt.1df4c372.svg";